/**
 * 个人会员详情
 */
export const MEMBER_PERSON_DETAIL_ROUTE = '/member/person/detail'

/**
 * 企业会员详情
 */
export const MEMBER_ENTERPRISE_DETAIL_PAGE_PATH = '/member/enterprise/detail'
